export default __webpack_public_path__ + "static/media/plus-square.b6e2c31a.svg";